import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.compHref,"target":_vm.compTarget}},[_c(VImg,_vm._g(_vm._b({staticClass:"base-logo",attrs:{"src":_vm.compSrc,"title":_vm.compAltText,"alt":_vm.compAltText,"contain":""}},'v-img',Object.assign({}, _vm.commonAttributes, _vm.$attrs),false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }